export default __webpack_public_path__ + "static/media/attractions_nearby.3485ef62.svg";